import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import { LeadsListContainer } from './containers/leads-list/leads-list.container';
import { LeadDetailsContainer } from './containers/lead-details/lead-details.container';
import { LeadsOpsContainer } from './containers/leads-ops/leads-ops.container';

export const LeadModule: React.FC = () => {
  // Resolved here, not in a module-level const. `RouteConfig` is an index
  // signature, so `APP_ROUTES.LEAD_MODULE` type-checks whether or not the key
  // exists — and a module-level read of a missing key throws during import,
  // which takes the whole admin app down with a blank screen rather than
  // breaking one route. That is exactly what happened in production when
  // these entries were added to the wrong object; every other module in this
  // repo reads APP_ROUTES at render time for the same reason.
  const children = APP_ROUTES.LEAD_MODULE.CHILDREN as RouteConfig;

  return (
    <>
      <Route exact path={APP_ROUTES.LEAD_MODULE.FULL_PATH}>
        <Redirect to={children.LIST.FULL_PATH} />
      </Route>
      {/* Details first, so `/leads/details/:leadId` is not swallowed by the list. */}
      <Route path={children.OPS.FULL_PATH} component={LeadsOpsContainer} />
      <Route path={children.DETAILS.FULL_PATH} component={LeadDetailsContainer} />
      <Route exact path={children.LIST.FULL_PATH} component={LeadsListContainer} />
    </>
  );
};
